/*
 * Requires the presence of `form` data
 * And optionally a `submitted` function to handle the success state
 */

const VueForm = {
    data () {
        return {
            sending: false,
            disabled: false,
            errors: {}
        }
    },
    created () {
        Object.keys(this.form).forEach(key => {
            this.$watch('form.' + key, (to, from) => { this.watchFormChanges(key, to, from) }, { deep: true })
        })
    },
    mounted () {
        const form = this.$refs[this.formRef || 'form']
        if (form && form.length > 0) {
            for (let i = 0; i < form.length; i++) {
                if (form[i] && ['INPUT', 'TEXTAREA', 'SELECT'].indexOf(form[i].nodeName) > -1) {
                    form[i].focus()
                    break
                }
            }
        }
    },
    methods: {
        watchFormChanges (key, to, from) {
            if (key in this.errors && this.errors[key]) {
                this.$set(this.errors, key, null)
            }

            if (this.disabled) {
                this.disabled = false
            }
        },
        submit () {
            if (this.disabled) {
                return false
            }

            Object.keys(this.form).forEach(key => {
                this.$set(this.errors, key, null)
            })

            let form = this.form
            if ('beforeSubmit' in this && typeof (this.beforeSubmit) === 'function') {
                const newProcessedForm = this.beforeSubmit(Object.assign({}, this.form))
                if (typeof newProcessedForm === 'object') {
                    form = newProcessedForm
                }
            }

            this.sending = true
            this.disabled = true

            const formRef = this.$refs[this.formRef || 'form']
            const formMethod = 'method' in formRef.dataset ? formRef.dataset.method.toLowerCase() : 'post'
            this.$http[formMethod](formRef.getAttribute('action'), form).then(response => {
                this.sending = false
                this.disabled = false
                if (typeof (this.processSubmit) === 'function') {
                    this.processSubmit(response.body)
                }
            }).catch(response => {
                this.sending = false
                this.disabled = false
                if ('errors' in response.body) {
                    Object.keys(response.body.errors).forEach(key => {
                        this.$set(this.errors, key, response.body.errors[key][0])
                    })
                } else {
                    this.$set(this.errors, Object.keys(this.errors)[0], response.body.error || 'An unexpected error occured.')
                }

                this.$nextTick(() => {
                    if (formRef.querySelector('.error')) {
                        const position = formRef.querySelector('.error').getBoundingClientRect().top - document.body.getBoundingClientRect().top
                        window.scrollTo({
                            top: position,
                            behavior: 'smooth'
                        })
                    }
                })
            })
        }
    }
}

export default VueForm
